import axios from "axios";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { format_currency } from "../../../utils/currencyUtils";

function Contracts({ onClose, contractid }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const { setGlobalLoading, token } = useOutletContext();
  const [contract, setContractData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [retainerData, setRetainerData] = useState([]);
  const [ContractFile, setContractFile] = useState([]);

  useEffect(() => {
    if (!contractid) return;
    setGlobalLoading(true);
    const fetchContractDetails = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/clients/get_contract_detail/`,
          { id: contractid },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response.data);
        setContractData(response.data.contract[0]);
        setCompanyData(response.data.comapnylevel);
        setRetainerData(response.data.retainersplit);
        setContractFile(response.data.contract_files);
      } catch (error) {
        console.error("Failed to fetch contract:", error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchContractDetails();
  }, [contractid]);

  const downloadFile = async (filename) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/contract_files/${filename}`, // or protected route
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <>
      {Object.keys(contract).length > 0 && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  Contract Details
                  {ContractFile?.savename && (
                    <button className="ms-2 btn btn-link p-0" onClick={() => downloadFile(ContractFile?.savename)}>
                      <i className="fa fa-download"></i>
                    </button>

                    // <a
                    //   className="ms-2"
                    //   target="_blank"
                    //   href={`${BASE_URL_BACK}contract_files/${ContractFile?.savename}`}
                    // >
                    //   <i className="fa fa-download"></i>
                    // </a>
                  )}
                </h4>
                <button
                  type="button"
                  onClick={onClose}
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xxl-12 col-lg-12 col-md-12">
                    <div className="card">
                      <div className="card-body my-card-body">
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">Client Name</span>
                              <p className="text-dark">
                                {contract.company_name}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Contract Name
                              </span>
                              <p className="text-dark">
                                {contract.contract_name}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">AGN No.</span>
                              <p className="text-primary mb-0 fw-bold">{contract.agn}</p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Contract Signed
                              </span>
                              <p className="text-dark">
                                {contract.contractsigned}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Contract Start
                              </span>
                              <h6 className="fw-normal d-flex align-items-center">
                                {contract.contractstart}
                              </h6>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">Contract End</span>
                              <h6 className="fw-normal d-flex align-items-center">
                                {contract.contractend}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Contract Status
                              </span>
                              <p className="text-dark">
                                {contract.contract_status}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Fee Percent
                              </span>
                              <p className="badge badge-soft-primary me-2 fs-14">
                                {contract.fee}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Expense Percent
                              </span>
                              <p className="text-dark">
                                {contract.expensePercent}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">Replacement</span>
                              <p className="text-dark">
                                {contract.candidateRegPeriod}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">Entity</span>
                              <h6 className="fw-normal d-flex align-items-center">
                                {contract.entity}
                              </h6>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">No Poach</span>
                              <p className="text-dark">
                                {contract.nopoachclause}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">Client Type</span>
                              <p className="text-dark">
                                {contract.client_type}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-1">
                              <span className="mb-1 d-block">
                                Retainer Type
                              </span>
                              <p className="text-dark">
                                {contract.clientretainertype}
                              </p>
                            </div>
                          </div>
                          {contract.candidateProfileValidity != "" &&
                            contract.candidateProfileValidity != null && (
                              <div className="col-sm-2">
                                <div className="mb-1">
                                  <span className="mb-1 d-block">
                                    Profile Validity
                                  </span>
                                  <p className="text-dark">
                                    {`${contract?.candidateProfileValidity} [${contract?.profileValidityFee}]`}
                                  </p>
                                </div>
                              </div>
                            )}
                          {contract.fee_cap_amount != "" &&
                            contract.fee_cap_amount != null &&
                            contract.fee_cap_amount != 0 && (
                              <div className="col-sm-2">
                                <div className="mb-1">
                                  <span className="mb-1 d-block">Fee Cap</span>
                                  <p className="text-dark">
                                    {`${contract?.symbol} [${contract?.fee_cap_amount}]`}
                                  </p>
                                </div>
                              </div>
                            )}
                          {contract.base_fee_cap_amount != "" &&
                            contract.base_fee_cap_amount != null && (
                              <div className="col-sm-2">
                                <div className="mb-1">
                                  <span className="mb-1 d-block">
                                    Base Fee Cap
                                  </span>
                                  <p className="text-dark">
                                    {`${contract?.symbol} [${contract?.base_fee_cap_amount}]`}
                                  </p>
                                </div>
                              </div>
                            )}
                          {contract?.fee &&
                            (() => {
                              const feeStr = contract.fee;

                              // Case 1: Has commas → split & count
                              if (feeStr.includes(",")) {
                                const feeArray = feeStr
                                  .split(",")
                                  .map((f) => f.trim());
                                const feeCount = feeArray.reduce((acc, val) => {
                                  acc[val] = (acc[val] || 0) + 1;
                                  return acc;
                                }, {});

                                return (
                                  <>
                                    <div className="col-sm-2">
                                      <div className="mb-1">
                                        <span className="mb-1 d-block">
                                          Base Fee Cap
                                        </span>
                                        <p className="text-dark d-flex">
                                          {Object.entries(feeCount).map(
                                            ([val, count], index) => (
                                              <span
                                                key={index}
                                                className="badge badge-soft-primary me-2"
                                              >
                                                {val} ({count}x)
                                              </span>
                                            )
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                );
                              }

                              // Case 2: Single value → show as-is
                              return (
                                <div className="col-sm-2">
                                  <div className="mb-1">
                                    <span className="mb-1 d-block">
                                      Base Fee Cap
                                    </span>
                                    <p className="badge badge-soft-primary me-2">
                                      {feeStr}
                                    </p>
                                  </div>
                                </div>
                              );
                            })()}
                        </div>
                      </div>
                      {retainerData.length > 0 && (
                        <div className="card-body my-card-body">
                          <div className="row">
                            <u>
                              <h6 className="fs-12">Retainer Splits</h6>
                            </u>
                            {retainerData.map((item, index) => (
                              <div key={index} className="col-sm-12">
                                <div className="mb-1">
                                  <p>
                                    <span className="text-dark">{`Retainer Split ${
                                      index + 1
                                    }`}</span>
                                    : {`${item.name} (${item.note})`}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {companyData.length > 0 &&
                        (contract.fee_type == "LevelWise" ||
                          contract.fee_cap_type == "LevelWise") && (
                          <div className="card-body my-card-body">
                            <div className="row table-responsive">
                              <table className="table table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th>Level Name</th>
                                    {contract.fee_type == "LevelWise" && (
                                      <th>Range</th>
                                    )}
                                    {contract.fee_type == "LevelWise" && (
                                      <th>Fixed Fee</th>
                                    )}
                                    {contract.fee_cap_type == "LevelWise" && (
                                      <th>Fee Cap Amount</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {companyData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.name}</td>
                                      {item.rangeFrom != null &&
                                        item.rangeTo != null &&
                                        contract.fee_type == "LevelWise" && (
                                          <td>
                                            {item.rangeFrom &&
                                            !item.rangeFrom.includes("-")
                                              ? `${item.rangeFrom}`
                                              : ""}{" "}
                                            -
                                            {item.rangeTo &&
                                            !item.rangeTo.includes("-")
                                              ? `${item.rangeTo}`
                                              : ""}
                                          </td>
                                        )}
                                      {item.amount != "" &&
                                        item.amount != null &&
                                        contract.fee_type == "LevelWise" && (
                                          <td>
                                            {item.amount.includes("%")
                                              ? item.amount
                                              : ` ${format_currency(
                                                  item.amount
                                                )}`}
                                          </td>
                                        )}
                                      {item.capAmount != "" &&
                                        item.capAmount != null &&
                                        contract.fee_cap_type ==
                                          "LevelWise" && (
                                          <td>{item.capAmount}</td>
                                        )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      <div className="card-body my-card-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mb-1">
                              <p>
                                <span className="text-dark">{`Comments : `}</span>
                                : {`${contract.comments}`}
                              </p>
                            </div>
                          </div>
                          {contract.contractdate != "" && (
                            <div className="col-sm-6">
                              <div className="mb-1">
                                <p>
                                  <span className="text-dark">{`Contact Created On : `}</span>
                                  {`${contract.contractdate}`}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Contracts;
